<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    :options="options"
    :disabled="isDisabled || $attrs.disabled"
    size="sm"
  >
    <template v-slot:label>
      Continuous Contract
      <HelperIcon>
        <i>
          A continuous contract is a contract that does not change UMR at each renewal. For more information click this 
        <a
          href="https://www.lloyds.com/conducting-business/delegated-authorities/market-knowledge/continuous-contracts"
          target="_blank"
          >READ MORE link</a
        >
        </i>
      </HelperIcon>
    </template>

    <template v-slot:first>
      <b-form-select-option :value="undefined" disabled
        >Select</b-form-select-option
      >
    </template>
  </BaseSelect>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { KEEP_AS_IS_OPTION, YES_NO_OPTIONS  } from '@constants'
import { useCurrentUser, useUserCompany } from '@composables'

import { BaseSelect } from '@components/base'
import { HelperIcon } from '@components/misc'

export default defineComponent({
  name: 'BDXEditFormContinuousContract',
  components: {
    BaseSelect,

    HelperIcon
  },
  props: {
    value: [String, Boolean],
    useKeepAsIsOption: Boolean,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()
    const { isRoleName: isCompanyRoleName } = useUserCompany()

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const isDisabled = computed(() => {
      if (isSuperUser.value) return false

      return !isCompanyRoleName('TPA') && !isCompanyRoleName('Underwriter')
    })
    let options =  YES_NO_OPTIONS;
    if (props.useKeepAsIsOption) {
      options = [KEEP_AS_IS_OPTION, ...options];
    }

    return {
      options,

      modelValue,
      isDisabled
    }
  }
})
</script>
